import { FormType } from 'signup-ui-lego-core/constants/FormType';
import { isQA } from '../../constants/apiEnvironments';
import { getGdprSubmissionText } from './getGdprSubmissionText';
export const DEFAULT_SUBSCRIPTION_TYPES = [16, 121, 7818550, 349169, 4898827, 50894, 1281077];
const FORM_TYPE_TO_SUBSCRIPTION_IDS = {
  [FormType.SignupCompleted]: DEFAULT_SUBSCRIPTION_TYPES,
  [FormType.SignupInterest]: [1281077]
};
const FORM_TYPE_TO_LEGAL_BASIS = {
  [FormType.SignupInterest]: 'LEAD',
  [FormType.SignupCompleted]: 'CUSTOMER'
};

const getSubscriptionIds = (formType = FormType.SignupCompleted) => {
  return isQA ? [11603285] : FORM_TYPE_TO_SUBSCRIPTION_IDS[formType];
};

export const getLegalConsentOptions = (formType = FormType.SignupCompleted) => {
  return {
    legitimateInterest: {
      value: true,
      text: getGdprSubmissionText(),
      subscriptionTypeIds: getSubscriptionIds(formType),
      legalBasis: FORM_TYPE_TO_LEGAL_BASIS[formType]
    }
  };
};
export const getLegalConsentOptionsForSignupRequest = () => {
  return {
    legitimateInterest: true,
    consentText: getGdprSubmissionText()
  };
};